import { msg } from '@gonfalon/messages/msg';

import { ApprovalsReviewKind } from './constants';
import { reviewKindToApprovalReviewStatus } from './reviewKindToApprovalReviewStatus';

export const getApprovalNotificationMessage = (reviewKind: ApprovalsReviewKind) => {
  if (reviewKind === ApprovalsReviewKind.COMMENT) {
    return msg('approvals.notification.commentAdded');
  }
  const reviewStatus = reviewKindToApprovalReviewStatus[reviewKind];
  return reviewKind !== ApprovalsReviewKind.DECLINE
    ? msg('approvals.notification.reviewSucceeded', { reviewStatus })
    : msg('approvals.notification.requestDeclined', { reviewStatus });
};
